import { ContentSection, Text } from '@cinch-labs/design-system'
import { storyblokEditable } from '@cinch-nx/data-storyblok'
import renderWithResolver from '@cinch-nx/landing-ui-shared/lib/rich-text-renderer/rich-text-renderer'
import Image from 'next/image'

import type { IntroSection as IntroProps } from '../../types/our-commitment-page'
import styles from './intro.module.css'

export const Intro: React.FC<IntroProps> = (blok) => {
  const { title, body, image } = blok

  return (
    <section {...storyblokEditable(blok)}>
      <Text
        fontSize="xxl"
        fontWeight="bold"
        element="h2"
        lineHeight="display"
        className={styles.title}
      >
        {title}
      </Text>
      <ContentSection>{renderWithResolver(body)}</ContentSection>
      <div className={styles.imageContainer}>
        <Image
          src={image.filename}
          alt={image.alt ?? ''}
          layout="fill"
          objectFit="cover"
        />
      </div>
    </section>
  )
}
